module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wod-results-page"
  }, [_c('div', {
    staticClass: "pp-all-header wod-results-page__header"
  }, [_c('img', {
    staticClass: "clickable wod-results-page__back",
    attrs: {
      "src": require("../../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title title-flex-center wod-results-page__title"
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_wod_results')) + ": " + _vm._s(_vm.currentDate))])]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenuStart wod-results-page__chips"
  }, _vm._l((_vm.wods), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectWod(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [(_vm.shouldShowMainName) ? _c('span', {
      class: _vm.getChipClass(item),
      style: (_vm.getDynamicColor('ti_filter'))
    }, [_vm._v(_vm._s(_vm.isSelectedWod(item) ? '✔ ' : '') + _vm._s(item.name) + " " + _vm._s(item.category != null ? '[' + item.category + ']' : ''))]) : _vm._e(), _vm._v(" "), (!_vm.shouldShowMainName) ? _c('span', {
      class: _vm.getChipClass(item),
      style: (_vm.getDynamicColor('ti_filter'))
    }, [_vm._v(_vm._s(_vm.isSelectedWod(item) ? '✔ ' : '') + " " + _vm._s(item.category != null ? item.category : ''))]) : _vm._e()])]), _vm._v(" \n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "scrollmenuStart section-top-sm wod-results-page__chips"
  }, _vm._l((_vm.genders), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectGender(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassGender(item),
      style: (_vm.getDynamicColor('ti_filter'))
    }, [_vm._v(_vm._s(_vm.isSelectedGender(item) ? '✔ ' : '') + _vm._s(item.name))])])]), _vm._v(" \n      ")])
  }), 0), _vm._v(" "), _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "center-wrapper"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderedResults), function(items, index) {
    return (!_vm.isLoading) ? _c('div', {
      staticClass: "section-top-sm"
    }, [_c('div', {
      staticClass: "wod-result-content wod-results-page__card"
    }, [_c('div', {
      staticClass: "wod-result-left result-left-pad"
    }, [_c('img', {
      staticClass: "avatar-circle-sm",
      attrs: {
        "src": items.allResults[0].profilePicture || _vm.logoImage,
        "alt": "Profile Picture"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wod-result-right-start",
      on: {
        "click": function($event) {
          items.details = !items.details;
        }
      }
    }, [_c('p', {
      staticClass: "wod-result-user"
    }, [_vm._v(_vm._s(items.allResults[0].name) + " " + _vm._s(items.allResults[0].surname))]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "wod-result-set"
    }, [_c('b', [_vm._v(_vm._s(_vm.locale.t('label_total_result')) + ":")]), _vm._v(" "), _c('b', {
      staticClass: "wod-result-set-bold"
    }, [_vm._v(_vm._s(_vm.formatWeightByMeasure(_vm.formatNumber(items.finalResult), items.finalMeasure)) + " " + _vm._s(items.finalMeasure))])])]), _vm._v(" "), _vm._l((items.allResults), function(result, index) {
      return (items.details) ? _c('div', [_c('p', {
        staticClass: "wod-result-set"
      }, [_c('b', [_vm._v(_vm._s(_vm.locale.t('label_result_set')) + " #" + _vm._s(index + 1) + ":")]), _vm._v(" "), _c('b', {
        staticClass: "wod-result-set-bold"
      }, [_vm._v(" " + _vm._s(_vm.formatWeightByMeasure(_vm.formatNumber(result.weight), result.measure)) + " " + _vm._s(result.measure))])])]) : _vm._e()
    }), _vm._v(" "), _c('p', {
      staticClass: "wod-result-set"
    }, [_c('i', {
      class: items.details ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
    }), _vm._v(" " + _vm._s(_vm.locale.t(items.details ? 'label_hide_details' : 'label_show_details')))])], 2), _vm._v(" "), _c('div', {
      staticClass: "wod-result-right-end"
    }, [_c('p', {
      staticClass: "wod-result-index wod-results-page__rank",
      style: (index < 3 ? '' : 'border: 0px solid;')
    }, [_vm._v(_vm._s(index + 1) + ".")])])])]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-352d305d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wod/WodUserResults.vue
// module id = 755
// module chunks = 0